import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';

const shareLink = async (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'object',
    required: true,
    properties: {
      url: {
        type: 'string',
        required: true,
        pattern: /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\s/$.?#].[^\s]*$/,
      },
      title: {
        type: 'string',
        required: true,
      },
      text: {
        type: 'string',
        required: true,
      },
    },
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return 'error';

  try {
    await navigator.share(arg);
    return 'success';
  } catch {
    console.error(`Link "${arg.url}" share error`);
    return 'error';
  }
};

export default shareLink;
